export default __webpack_public_path__ + "static/jogger-c8f22f7f6d02fc5022c62d46c9e9350a.svg";